import { DialogTitle, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import { useForm, FormPresenter, useMenu } from 'common/hooks';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { isNonEmpty } from './utils';

interface DialogProps {
  open: boolean;
  onClose: (confirmed: boolean, forceClose?: boolean) => void;

  title?: React.ReactNode;
  message: React.ReactNode;
  actionConfirm: string;
  actionCancel: string;

  disableBackdropClick?: boolean;

  extraButton?: string;

  forceClose?: () => void;
  style?: React.CSSProperties;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    minWidth: 300,
    display: 'flex',
    alignItems: 'center',
  },
}));

export const useConfirmDialog = (disableBackdropClick?: boolean) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<React.ReactNode>('');
  const [message, setMessage] = useState<React.ReactNode>('');
  const [actionCancel, setActionCancel] = useState('');
  const [actionConfirm, setActionConfirm] = useState('');
  const [actionExtra, setActionExtra] = useState('');
  // const onClose = React.useRef((_: boolean) => {});
  const [onClose, setOnClose] = useState({
    current: (confirmed: boolean, forceClose?: boolean) => { },
  });

  return {
    render: (customStyle?: React.CSSProperties) => <ConfirmDialog
      disableBackdropClick
      open={open} onClose={onClose.current ?? (() => { })}
      title={title}
      message={message}
      actionCancel={actionCancel} actionConfirm={actionConfirm}
      extraButton={actionExtra}
      style={customStyle}
    />,
    confirm: (message: React.ReactNode, actionConfirm: string, actionCancel: string, title = '', actionExtra?: string): Promise<boolean> => {
      setOpen(true);
      setTitle(title);
      setMessage(message);
      setActionCancel(actionCancel);
      setActionConfirm(actionConfirm);
      setActionExtra(actionExtra ?? '');
      return new Promise<boolean>((resolve) => {
        setOnClose({
          current: (confirmed, forceClose?) => {
            if (forceClose) {
              setOpen(false);
            } else {
              resolve(confirmed);
              setOpen(false);
            }
          },
        });
      });
    },
  }
}

export const ConfirmDialog = ({ open, onClose, message, actionCancel, actionConfirm, title, disableBackdropClick, extraButton, forceClose, style }: DialogProps) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        disableBackdropClick
        open={open}
        onClose={() => onClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={style}
      >
        {isNonEmpty(title) ?
          <DialogTitle><Typography style={{ fontWeight: 'bold' }}>{title}</Typography></DialogTitle>
          : null}
        <DialogContent className={classes.dialogContent}>
          <DialogContentText id="alert-dialog-description" style={{ width: '100%', whiteSpace: 'pre-line' }}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {extraButton ? <Button onClick={() => onClose(false, true)} color="primary">
            {extraButton}
          </Button> : null}
          {actionCancel ? <Button onClick={() => onClose(false)} color="primary">
            {actionCancel}
          </Button> : null}
          {actionConfirm ? <Button onClick={() => onClose(true)} color="primary" variant="contained" autoFocus>
            {actionConfirm}
          </Button> : null}
        </DialogActions>
      </Dialog>
    </div >
  );
}

export default ConfirmDialog;